import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import ErrorIcon from '@material-ui/icons/Error';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    icon: {
        width: '2em',
        height: '2em',
        margin: '1em',
        color: "#D51535"
    },
    content: {
        display: 'flex',
        flexDirection: 'column' as 'column',
        alignItems: 'center'
    }
}))

interface IProps {
    error: string
    onClose: () => void;
}

const ErrorDialog: React.FC<IProps> = ({ error, onClose }: IProps) => {

    const classes = useStyles();

    return (
        <Dialog
            disableBackdropClick
            disableEscapeKeyDown
            maxWidth="xs"
            aria-labelledby="confirmation-dialog-title"
            open={error.length > 0}
        >
            <DialogContent className={classes.content} dividers>
                <ErrorIcon
                    className={classes.icon}
                />
                <Typography variant="body1">
                    {error}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ErrorDialog;